// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"289":"recipes-home","627":"schedule-home","703":"preparations-home","966":"operators-home"}[chunkId] || chunkId) + ".js";
};